/**
 * How one slot of a container is drawn, wherever it is drawn.
 *
 * A bag, a bank and a trade window are the same square with the same thing in
 * it, so a stack of coins should read the same way in all three rather than
 * three ways. Held apart from the components that use them so that sharing them
 * does not stop any of those components reloading while somebody works.
 */

/** Stacks past this are shown short, the way a bank balance is. */
export function shortQuantity(quantity: number): string {
  if (quantity >= 10_000_000) return `${Math.floor(quantity / 1_000_000)}M`;
  if (quantity >= 100_000) return `${Math.floor(quantity / 1000)}K`;
  return String(quantity);
}

/** Two letters standing in for a picture, until there are pictures. */
export function initials(name: string): string {
  const words = name.split(' ').filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1) return (words[0] ?? '').slice(0, 2).toUpperCase();
  return `${(words[0] ?? '').slice(0, 1)}${(words[1] ?? '').slice(0, 1)}`.toUpperCase();
}

/** A stable colour per item, so the same thing always looks the same. */
export function tint(itemId: number): string {
  return `hsl(${(itemId * 47) % 360} 38% 38%)`;
}
